module.exports = __webpack_public_path__ + "static/media/source_book_2.8c97bee4.png";